module.exports = __webpack_public_path__ + "img/maneken_pos_4.208c6c6a.png";